<div class="card-wrapper">
    <div class="summary-list">
        <div class="card-input-wrapper">
            <div class="card-input">
                <div>
                    <p class="card-label">Card Number</p>
                </div>
                <div class="basic-inputs card-number-input" id="card-number"></div>
            </div>
        </div>
        <div class="card-input-wrapper-2">
            <div class="date-wrapper">
                <div class="card-input">
                    <div>
                        <p class="card-label">Expire Date</p>
                    </div>
                    <div class="stripe-input-short" id="card-expiry"></div>
                </div>
            </div>
            <div class="cvc-wrapper">
                <div class="card-input">
                    <div>
                        <p class="card-label">CVV</p>
                    </div>
                    <div class="stripe-input-short" id="card-cvc"></div>
                </div>
            </div>
        </div>
        <div class="ion-text-center">
            <ion-button *ngIf="!payment?.paying" class="half-button ion-text-wrap" size="large" type="button" (click)="submit()">
                <ion-ripple-effect></ion-ripple-effect>
                Book Now
            </ion-button>
        </div>
        <div class="note-card-container">
            <ion-card class="note-card">
                <div>
                    <div class="card-header">
                        <ion-label class="section-title" color="secondary">
                            <fa-icon [icon]="faExclamationCircle"></fa-icon>
                            Please note:
                        </ion-label>
                    </div>
                </div>
                <ion-text color="text">
                    <p class="card-text">{{ (toolService.content | async)?.payment?.components?.stripe?.discretion }}</p>
                    <div class="card-errors ion-text-center" id="card-errors" role="alert"></div>
                </ion-text>
            </ion-card>
        </div>
    </div>
</div>
